/**
 * Gestión → Inventario · **Salidas** (`/gestion/inventario/salidas`).
 *
 * Puerto de `Inventario::salida` + `views/menu/inventario/salida.php`: el
 * histórico de retiros de stock (`salida`/`detalle_salida`) con su usuario, el
 * producto, la cantidad, la razón y la anulación del movimiento.
 */

import { ArrowLeft, ArrowUpFromLine } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useDocumentTitle } from '@/hooks/use-document-title';

import { InventarioNav } from '../components/inventario-nav';
import { InventarioMovimientos } from '../components/inventario-movimientos';
import { useInventario } from '../inventario.api';

export function InventarioSalidasPage() {
  useDocumentTitle('Gestión · Inventario · Salidas');
  const inventario = useInventario();

  const productos = (inventario.data?.productos ?? []).map((producto) => ({
    id: producto.id,
    nombre: producto.nombre,
    unidad: producto.unidad,
  }));

  return (
    <div className="space-y-5">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <Link
            to="/inicio/gestion"
            className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-ink-400 transition-colors hover:text-brand-600"
          >
            <ArrowLeft className="size-3" aria-hidden="true" />
            Gestión
          </Link>
          <h1 className="mt-1 flex items-center gap-2 text-2xl font-bold tracking-tight text-ink-900">
            <ArrowUpFromLine className="size-6 text-brand-500" aria-hidden="true" />
            Inventario · Salidas
          </h1>
          <p className="mt-1 max-w-2xl text-sm text-ink-500">
            Retiros de stock registrados, con su razón (salida temporal, prueba de máquina o retiro
            de galonaje no vendido) y la anulación del movimiento.
          </p>
        </div>

        <InventarioNav active="salidas" />
      </header>

      <InventarioMovimientos tipo="salida" productos={productos} />
    </div>
  );
}
